import type { PaymentRequestWallet } from '@stripe/stripe-js'

import { renderTemplate, TEXT } from './text'

export type PaymentContactInfo = {
    fullName: string
    email: string
    phone?: string
}

export type TokenizedCard = {
    last4: string
    token: string
    type: CardTypeForDisplay
}

export enum CardTypeForDisplay {
    Credit = 'credit',
    Debit = 'debit',
    Prepaid = 'prepaid',
    Other = 'other',
}

export type PaymentAddress = {
    zipPostalCode: string
}

export type PaymentFormValues = {
    addressInfo: PaymentAddress
    contactInfo: PaymentContactInfo
    cardToken: string
}

export function formatCard(
    card: TokenizedCard,
    walletName?: PaymentRequestWallet
) {
    if (walletName) {
        return TEXT.wallets[walletName]
    }

    return renderTemplate(TEXT.cardMask[card.type], {
        last4: card.last4,
    })
}
